export const ACTUALIZAR_LIST_EQPG = "ACTUALIZAR_LIST_EQPG";
export const MODIFICAR_EQPG = "MODIFICAR_EQPG";
export const AGREGAR_EQPG = "AGREGAR_EQPG";
export const ELIMINAR_EQPG = "ELIMINAR_EQPG";
